import React from "react"
import axios from "axios";
import { setup as URI_SETUP } from "../../../../config/api";

const uri_explore_csv = URI_SETUP+"data_source/csv/explore";
const uri_upload_schema = URI_SETUP+"data_source/csv/schema";

class ImportData extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            col_sch_mleap_status            :   "hide",
            col_data_origin_status          :   "hide",
            col_sch_history_status          :   "hide",
            modal_new_sch_status            :   "hide",
            modal_save_sch_status            :  "hide",
            background_filter               :   "",
            dbfile                          :   "",
            dbtype                          :   "",
            dbtype_name                     :   "",
            sh_mleap_open                   :   "",
            file_name                       :   "CHOOSE FILE",
            lst_mleap_structure             :   [],
            lst_dbfile_structure            :   [],
            parsing_schema_active           :   "",
            schema_name                     :   "",             
            budget_period                   :   "day"

            }
    }


    // ----------------------- Handlers -----------------------

    handleFileSelector(e) {
        if(e[0] != undefined){
            this.setState({ 
                dbfile      : e[0],
                file_name   : e[0].name
                })
        }
    }

    handleBudgetPeriod(e) {
        if(e != undefined){
            this.setState({ 
                budget_period  : e.currentTarget.value
                })
        }
    }

    handleSchemaTypeChange = (event) => {
        var index = event.nativeEvent.target.selectedIndex;
        this.setState({ 
            dbtype      : event.target.value,
            dbtype_name : event.nativeEvent.target[index].text
            })
    }

    handleSchMagnumOpen(key){
        let item_opened = "";
        if(this.state.sh_mleap_open!=key){
            item_opened = key;
        }
        this.setState({ 
            sh_mleap_open   : item_opened
            }) 
    }

    handleSchemaNameChange = (e) => {
        this.setState({
            schema_name : e.target.value
        });
    }



    // ----------------------- Functions -----------------------

    newSchema() {
        this.setState({ 
            modal_new_sch_status            : "",
            background_filter               : "blur",
            file_name                       :   "CHOOSE FILE",
            lst_mleap_structure             :   [],
            lst_dbfile_structure            :   [],
            dbfile                          :   "",
            dbtype                          :   [],
            col_sch_mleap_status            :   "hide",
            col_data_origin_status          :   "hide"
            })
    }
    
    cancelNewSchema(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            modal_new_sch_status    : "hide",
            background_filter       : "",
            dbfile                  : "",
            file_name               : "CHOOSE FILE"
            })
    }

    cancelSchema(e){
        let self = this;
        self.setState({ 
            lst_mleap_structure           : [],
            lst_dbfile_structure          : [],
            col_data_origin_status        : "hide",
            col_sch_mleap_status          : "hide",
            schema_name                   : ""
            })
    }

    saveSchema() {
        this.setState({ 
            modal_save_sch_status         : "",
            background_filter             : "blur"
            })
    }

    cancelSaveSchema(){
        let self = this;
        self.setState({ 
            modal_save_sch_status   : "hide",
            background_filter       : ""
            })
    }

    onSubmitDefineSchema(e){
        let self = this;            
        e.preventDefault();

        if(this.state.dbfile!='' && self.state.dbtype!=''){

            let formData = new FormData();
            formData.append('api_token',localStorage.getItem("api_token"));
            formData.append('dbfile', self.state.dbfile);
            formData.append('dbtype', self.state.dbtype);

            const config = {
                onUploadProgress:function (progressEvent) {
                    const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                    
                    
                    //console.log("onUploadProgress", totalLength);
                    if (totalLength !== null) {
                        //console.log(Math.round( (progressEvent.loaded * 100) / totalLength ));
                    }
                }
            };

            axios.post(uri_explore_csv, formData, config).then(request => { 
                        self.setState({ 
                            modal_new_sch_status    : "hide",
                            background_filter       : "",
                            col_sch_mleap_status    : "",
                            col_data_origin_status  : "",
                            lst_mleap_structure     : request.data.magnum_schema,
                            lst_dbfile_structure    : request.data.uploaded_file,
                            })
                        
                    })  
            
        }
        
    }

    onDragStart = (ev, index) => {
        ev.dataTransfer.setData("index", index);
    }

    onDragOver = (ev) => {
        ev.preventDefault();
    }

    onDrop = (ev, key) => {

        let index = ev.dataTransfer.getData("index");
        const lst_mleap_structure = this.state.lst_mleap_structure;
        const lst_dbfile_structure = this.state.lst_dbfile_structure;

        if(lst_mleap_structure[key].value_type==lst_dbfile_structure[index].value_type 
            || lst_mleap_structure[key].value_type=="Text"
            || lst_dbfile_structure[index].value_type ==''){
            if(lst_mleap_structure[key].value!=""){
                lst_dbfile_structure[lst_mleap_structure[key].value].unassigned = true;
            }
    
            lst_mleap_structure[key].value = index;
            lst_dbfile_structure[index].unassigned = false;
            
            this.setState({
                lst_mleap_structure,
                lst_dbfile_structure
            });

        }


    }

    unassignValue (key) {
        
        const lst_dbfile_structure = this.state.lst_dbfile_structure;
        const lst_mleap_structure = this.state.lst_mleap_structure;

        lst_dbfile_structure[this.state.lst_mleap_structure[key].value].unassigned = true;
        lst_mleap_structure[key].value = "";

        this.setState({
            lst_mleap_structure,
            lst_dbfile_structure
        });
     }

    onSubmitSchema(e){
        let self = this;            
        e.preventDefault();
        
        if(this.state.dbfile!='' && self.state.dbtype!=''){

            let formData = new FormData();
            formData.append('api_token',localStorage.getItem("api_token"));
            formData.append('name',this.state.schema_name);
            formData.append('schema_property',this.props.app.state.hotel_selected);
            if(this.state.dbtype=="budget"){
                formData.append('dbtype',this.state.dbtype+"_"+this.state.budget_period);
            }else{
                formData.append('dbtype',this.state.dbtype);
            }

            Object.keys(this.state.lst_mleap_structure).map((key, index) => {
                if(this.state.lst_dbfile_structure[this.state.lst_mleap_structure[key].value]!=undefined){
                    formData.append(key+'[name]', this.state.lst_dbfile_structure[this.state.lst_mleap_structure[key].value].name);
                    formData.append(key+'[position]', this.state.lst_mleap_structure[key].value);
                }
            });

            axios.post(uri_upload_schema, formData)
                    .then(request => { 
                        this.props.setActiveHotel(this.props.app.state.hotel_selected);
                        self.setState({ 
                            modal_save_sch_status         : "hide",
                            background_filter             : "",
                            lst_mleap_structure           : [],
                            lst_dbfile_structure          : [],
                            col_data_origin_status        : "hide",
                            col_sch_mleap_status          : "hide",
                            schema_name                   : "",
                            dbfile                        : "",
                            file_name                     : "CHOOSE FILE"
                            })  
                    })
            
        }
        
    }


    // ----------------------- Renders -----------------------

    renderSelectParsingSchemas() {
        let self = this;
        return <ul>
                    {   
                        Object.keys(self.props.app.state.parsing_schema_list).map((key, index) => {
                            return (<li className="clickable" key={index} > 
                                <div>
                                    <div className="ellipsed">{self.props.app.state.parsing_schema_list[key].name}</div> 
                                    <i className="fa fa-angle-down"></i>
                                </div>
                            </li>);
                        })
                    }
                </ul>   
    }

    renderFieldValue(key) {
        if (this.state.lst_mleap_structure[key].value!=""){
            return <ul className="alias-listing" 
                    onDragOver={(e)=>this.onDragOver(e)}
                    onDrop={(e)=>{this.onDrop(e, key)}}>

                            <li>
                                <div className="item-with-details">
                                    {this.state.lst_dbfile_structure[this.state.lst_mleap_structure[key].value].name}
                                    <br />
                                    <i className="fa fa-times-circle remove clickable" onClick={this.unassignValue.bind(this,key)} ></i>
                                    <span className="item-details">
                                        {this.state.lst_dbfile_structure[this.state.lst_mleap_structure[key].value].example}  
                                        <i> {this.state.lst_dbfile_structure[this.state.lst_mleap_structure[key].value].value_type}</i>
                                    </span>
                                    
                                </div>
                            </li> 
                </ul>   

        }else{
            return <ul className="alias-listing" 
                    onDragOver={(e)=>this.onDragOver(e)}
                    onDrop={(e)=>{this.onDrop(e, key)}}>
                    </ul>   

        }
    }

    renderMagnumStructure() {
        return  <ul className="list-scrollable">
                    <li className="list-header"><div className="label">{this.state.dbtype_name} </div></li>
                    {this.state.dbtype=="budget" &&
                        <li className="radio-inlist">
                            <p>Budget defined by:</p>
                            <div className="radio" >
                                <label><input type="radio" name="budget_period" value="day" onClick={this.handleBudgetPeriod.bind(this)}  defaultChecked={this.state.budget_period} />Day</label>
                            </div>
                            <div className="radio">
                                <label><input type="radio" name="budget_period" value="month" onClick={this.handleBudgetPeriod.bind(this)} defaultChecked={this.state.budget_period} />Month</label>
                            </div>
                            <div className="radio">
                                <label><input type="radio" name="budget_period" value="year" onClick={this.handleBudgetPeriod.bind(this)}  defaultChecked={this.state.budget_period} />Year</label>
                            </div>

                        </li>   
                    }
                    {Object.keys(this.state.lst_mleap_structure).map((key, index) => {
                        return (<li key={key}
                                    className={"sub-list " + (this.state.sh_mleap_open==key? "" : "collapsed" )}
                                >
                                    <div className="item-with-details">
                                        {this.state.lst_mleap_structure[key].name}
                                        
                                        <i  className={"clickable fa " + (this.state.sh_mleap_open==key? "fa-angle-up" : "fa-angle-down" )} 
                                            onClick={this.handleSchMagnumOpen.bind(this,key)} >
                                        </i>
                                        <span className= {(this.state.lst_mleap_structure[key].value=="")? "hidden" : "float-right circle-note gray"  } > 1 </span>
                                        <br />
                                        <span className="item-details">
                                            {this.state.lst_mleap_structure[key].example}  
                                            <i> {this.state.lst_mleap_structure[key].value_type}</i>
                                        </span>
                                        

                                    </div>
                                    {this.renderFieldValue(key) }
                                </li>);
                        }
                    )
                        
                    }
                </ul>   
    }
    
    renderFileStructure() {
        return  <ul>
                    <li className="sub-list" ><div>File Structure <i className="fa fa-angle-down"></i>  </div>
                        <ul>
                             {Object.keys(this.state.lst_dbfile_structure).map((key, index) => {
                                 if(this.state.lst_dbfile_structure[key].position!=undefined){
                                     if(this.state.lst_dbfile_structure[key].unassigned) {
                                        return (<li key={index} className="clickable" draggable="true" onDragStart = {(e) => this.onDragStart(e, index)} >
                                                    <div className="item-with-details">
                                                        {this.state.lst_dbfile_structure[key].name}
                                                        <br />
                                                        <span className="item-details">
                                                            {this.state.lst_dbfile_structure[key].example}  
                                                            <i> {this.state.lst_dbfile_structure[key].value_type}</i>
                                                        </span>
                                                    </div>
                                                </li>);
                                        }
                                    }
                                })
                            }
                        </ul>
                    </li>
                        
                </ul>   
    }

    renderNewSchema() {
        return <div className="box regular col-md-4 ">
                    <h3>DEFINE NEW SCHEMA  <i className="fa fa-times-circle" onClick={this.cancelNewSchema.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="schema_form" onSubmit={this.onSubmitDefineSchema.bind(this)}>
                            <div className="form-row form-modal">
                                <div className="col col-md-12"> 
                                    <select className="form-control " value={this.state.dbtype} name="db_type" onChange={this.handleSchemaTypeChange} required  >
                                        <option disabled value="">Schema type</option>
                                        <option value="reservations">Reservations</option>
                                        <option value="budget">Budget</option>
                                        <option value="room_stock">Availability</option>
                                    </select> 
                                </div> 
                            </div>
                            
                            <div className="form-row importing-csv">
                                <div className="col col-md-9">
                                    <button>{this.state.file_name} </button>
                                    <input type="file" name="dbfile" onChange={ (e) => this.handleFileSelector(e.target.files) } /> 
                                </div>
                            
                                <div className="col col-md-3">
                                    <select className="form-control " name="file_type" >
                                        <option disabled>FILE TYPE</option>
                                        <option value="csv">.csv</option>
                                    </select>   
                                </div>
                            </div>
                            
                            <div className="form-row modal-buttons">
                                <div className="col col-md-6">
                                    <button onClick={this.cancelNewSchema.bind(this)}>CANCEL</button>   
                                </div>
                                <div className="col col-md-6">
                                    <button type="submit" className="blue" >DEFINE</button> 
                                </div>
                            </div>
                            
                        </form>
                    </div>
                </div>

    }

    renderSaveSchema() {
        return <div className="box regular col-md-4 ">
                    <h3>SAVE SCHEMA  <i className="fa fa-times-circle" onClick={this.cancelSaveSchema.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="schema_form" onSubmit={this.onSubmitSchema.bind(this)}>
                                <div className="form-row form-modal">
                                    <div className="col col-md-12"> 
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={this.state.schema_name} required  onChange={e => this.handleSchemaNameChange(e)} />          
                                </div> 
                            </div>
                            <div className="form-row modal-buttons">
                                <div className="col col-md-6">
                                    <button onClick={this.cancelSaveSchema.bind(this)}>CANCEL</button>   
                                </div>
                                <div className="col col-md-6">
                                    <button type="submit" className="blue" >SAVE</button> 
                                </div>
                            </div>
                            
                        </form>
                    </div>
                </div>

    }

    render() {
        return (
            <section>
                <div className={this.state.background_filter}>
                    <div className="top-form ">
                        <form id="catalog_item_form"  >
                            <div className="form-row">
                                <div className="col col-md-3">
                                    {this.props.renderSelectHotels()}
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="head-content "> 
                            <div className="icon col-md-2 px-2">
                                <h1>Setup</h1>
                                <h2>Data Import </h2>
                            </div>
                            <div className="col-md-8 px-2">    
                                
                                <div className="description">
                                    <p className="desc-no-icon"><strong>When setting up the data import configuration, </strong> <br/> it’s important that the words that your client database (or PMS) already uses EXACTLY match the words that you add to Magnum Leap in this step. It’s as if your client database is one puzzle piece and you’re making the puzzle piece that will fit perfectly with your database.</p>
                                </div>
                            </div>
                    </div>

                    <div className="col-md-12 no-padding"> 
                        <div className="box regular col-md-4">
                            <h3>SCHEMAS DEFINED</h3>
                            <div className="list-in-box">
                                { this.renderSelectParsingSchemas() }
                                <button className="blue" onClick={this.newSchema.bind(this)}>NEW</button>
                            </div>
                        </div>
                        <div className={"box regular col-md-4 " + this.state.col_sch_history_status}>
                            <h3>IMPORTATION HISTORY</h3>
                            <div className="list-in-box">
                                
                            </div>
                        </div>
                        <div className={"box regular col-md-4 " + this.state.col_sch_mleap_status}>
                            <h3>MAGNUM LEAP EXPRESSIONS</h3>
                            <div className="list-in-box">
                                {this.renderMagnumStructure()}
                            </div>
                            <div className="col-md-6 bottom-buttons">
                                <button onClick={this.cancelSchema.bind(this)}>CANCEL</button>
                            </div>
                            <div className="col-md-6 bottom-buttons">
                                <button className="blue" onClick={this.saveSchema.bind(this)}>SAVE</button> 
                            </div>
                        </div>
                        <div className={"box regular col-md-4 " + this.state.col_data_origin_status}>
                            <h3>DATA ORIGIN</h3>
                            <div className="list-in-box">
                                {this.renderFileStructure()}
                            </div>
                        </div>
                        
                    </div>
                </div>

                <div className={"modal " + this.state.modal_new_sch_status}> 
                    {this.renderNewSchema()}
                </div>

                <div className={"modal " + this.state.modal_save_sch_status}> 
                    {this.renderSaveSchema()}
                </div>

            </section>
        )
    }

}

export default ImportData


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/ImportData.js